export default "__VITE_PUBLIC_ASSET__52a1f654__"